import React from 'react';
import PropTypes from 'prop-types';
/* Components */
import ModalDefault from './modal-default';

class ModalDelete extends React.PureComponent {
  render() {
    return (
      <ModalDefault isOpen={this.props.isOpen} onCancel={this.props.onCancel}>
        <div className="glu-modal__header">
          <div className="glu-modal__title glu-flex-grow glu-break-all">
            Delete {this.props.itemLabel ? this.props.itemLabel : ''}
          </div>
          <div className="glu-flex-shrink">
            <button
              aria-label="close"
              type="button"
              className="glu-btn-link g-icon g-icon-close"
              onClick={this.props.onCancel}
            />
          </div>
        </div>
        <div className="glu-modal__body">
          <div className="glu-content__section glu-modal__text">
            {this.props.children
              ? this.props.children
              : 'Are you sure you want to delete this item?'}
          </div>
        </div>
        <footer className="glu-modal__footer glu-flex-row">
          <div className="glu-flex-grow glu-flex-row glu-flex-align-center">
            <div className="glu-flex-grow text-right">
              <button onClick={this.props.onCancel} className="glu-btn glu-btn--secondary">
                Cancel
              </button>
            </div>
            <div className="glu-flex-shrink">
              <button onClick={this.props.onDelete} className="glu-btn glu-btn--primary">
                Delete
              </button>
            </div>
          </div>
        </footer>
      </ModalDefault>
    );
  }
}

ModalDelete.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  itemLabel: PropTypes.string,
};

ModalDelete.defaultProps = {
  children: null,
  isOpen: false,
  itemLabel: '',
};

export default ModalDelete;
